export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/common-user-service-stack-form';
